//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
    getorderList,
    winningConfirm
} from '../../../api';
import MHeader from '../../Header/Header.vue';
export default {
    components: {
        MHeader,
    },
    data() {
        return {
            data: ""
        }
    },
    created() {
        this.$store.commit('showIsLoading');
        getorderList(`rob_id=${this.$route.params.rob_id}`).then(res => {
            if (res.data.error_code) {
                this.$router.go(-1);
                console.log(res);
                return;
            };
            this.data = res.data.data;
            console.log(res);
        });
    },
    methods: {
        winningConfirmBtn(tid) {
            winningConfirm(`tid=${tid}`).then(res => {
                if (res.data.error_code) {
                    this.$store.commit('updateToast', {
                        show: true,
                        text: res.data.msg
                    });
                    console.error(res);
                    return;
                };
                this.$store.commit('updateToast', {
                    test: res.data.msg,
                    show: true
                });
            })
        }
    },
    filters: {
        statusName(val) {
            switch (val) {
                case "0":
                    return '待发货';
                case '1':
                    return '待收货'
                default:
                    return '交易完成'
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/UserCenter/winning/winningDetail.vue